<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('学生管理') }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
        >
          {{ $t('添加学生') }}
        </el-button>
        <el-button
          style="float: right; padding: 3px 0; margin-right: 10px;"
          type="success"
          icon="el-icon-upload"
          @click="handleBatchImport"
        >
          {{ $t('批量导入') }}
        </el-button>
      </div>

      <div class="filter-container">
        <el-row :gutter="10">
          <el-col :md="6" :sm="8">
            <div>
              <el-input v-model="listQuery.searchword" :placeholder="$t('请输入学生姓名、手机号、微信号或留言详情')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
            </div>
          </el-col>
          <el-col :md="5" :sm="7">
            <div>
              <el-date-picker v-model="listQuery.start_time" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" clearable style="width: 100%;" class="filter-item" />
            </div>
          </el-col>
          <el-col :md="5" :sm="7">
            <div>
              <el-date-picker v-model="listQuery.end_time" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" clearable style="width: 100%;" class="filter-item" />
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item1" :placeholder="$t('国硕代理项目')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item2" :placeholder="$t('美国硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item3" :placeholder="$t('新业务硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item4" :placeholder="$t('硕博在线项目')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item5" :placeholder="$t('才大硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item6" :placeholder="$t('北京硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item7" :placeholder="$t('国际硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item8" :placeholder="$t('研之堂硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item9" :placeholder="$t('网络硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item10" :placeholder="$t('博士项目')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="6">
            <div>
              <el-select v-model="listQuery.item11" :placeholder="$t('重庆硕博')" clearable class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in itemStatusOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
              </el-select>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :md="3" :sm="3">
            <div>
              <el-button
                v-waves
                class="filter-item"
                type="success"
                icon="el-icon-download"
                style="width:100%;"
                :disabled="!showDeletebtn"
                @click="handleExport"
              >
                {{ $t('导出选中') }}
              </el-button>
            </div>
          </el-col>
          <el-col :md="3" :sm="3">
            <div>
              <el-select v-model="listQuery.order" class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="3">
            <div>
              <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" style="width: 100%;" @click="handleFilter">
                {{ $t('搜索') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-table
        ref="studentTable"
        v-loading="listLoading"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :data="list"
        class="border-gray"
        fit
        highlight-current-row
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />

        <el-table-column width="80px" align="left" :label="$t('ID')" fixed="left">
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" :label="$t('姓名')" fixed="left">
          <template slot-scope="{row}">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column width="80px" align="center" :label="$t('年龄')">
          <template slot-scope="{row}">
            <span>{{ row.age }}</span>
          </template>
        </el-table-column>

        <el-table-column width="80px" align="center" :label="$t('性别')">
          <template slot-scope="{row}">
            <el-tag :type="row.gender == 1 ? 'primary' : 'success'" size="mini">
              {{ row.gender == 1 ? $t('男') : $t('女') }}
            </el-tag>
          </template>
        </el-table-column> -->

        <el-table-column min-width="120px" :label="$t('手机号')" fixed="left">
          <template slot-scope="{row}">
            <span>{{ row.phone || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" :label="$t('微信号')" fixed="left">
          <template slot-scope="{row}">
            <span>{{ row.wechat || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="200px" :label="$t('留言详情')">
          <template slot-scope="{row}">
            <span>{{ row.message_detail || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('国硕代理项目')">
          <template slot-scope="{row}">
            <span v-if="row.item1 === 0">-</span>
            <i v-else-if="row.item1 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item1 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item1 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110px" align="center" :label="$t('美国硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item2 === 0">-</span>
            <i v-else-if="row.item2 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item2 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item2 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('新业务硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item3 === 0">-</span>
            <i v-else-if="row.item3 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item3 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item3 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="130px" align="center" :label="$t('硕博在线项目')">
          <template slot-scope="{row}">
            <span v-if="row.item4 === 0">-</span>
            <i v-else-if="row.item4 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item4 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item4 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('才大硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item5 === 0">-</span>
            <i v-else-if="row.item5 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item5 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item5 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('北京硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item6 === 0">-</span>
            <i v-else-if="row.item6 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item6 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item6 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('国际硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item7 === 0">-</span>
            <i v-else-if="row.item7 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item7 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item7 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('研之堂硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item8 === 0">-</span>
            <i v-else-if="row.item8 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item8 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item8 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('网络硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item9 === 0">-</span>
            <i v-else-if="row.item9 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item9 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item9 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('博士项目')">
          <template slot-scope="{row}">
            <span v-if="row.item10 === 0">-</span>
            <i v-else-if="row.item10 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item10 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item10 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" align="center" :label="$t('重庆硕博')">
          <template slot-scope="{row}">
            <span v-if="row.item11 === 0">-</span>
            <i v-else-if="row.item11 === 1" class="el-icon-warning" style="color: #E6A23C; font-size: 18px;" />
            <i v-else-if="row.item11 === 2" class="el-icon-success" style="color: #67C23A; font-size: 18px;" />
            <i v-else-if="row.item11 === 3" class="el-icon-error" style="color: #F56C6C; font-size: 18px;" />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column width="170px" align="left" :label="$t('创建时间')">
          <template slot-scope="scope">
            <span class="text-muted">
              <i class="el-icon-time" />&nbsp;
              {{ scope.row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="pageSizes"
        @pagination="getList"
      />
    </el-card>

    <!-- 学生详情对话框 -->
    <el-dialog
      :title="$t('学生详情')"
      :visible.sync="detail.dialogVisible"
    >
      <detail :data="detail.data" />
    </el-dialog>

    <!-- 添加学生对话框 -->
    <el-dialog
      :title="$t('添加学生')"
      :visible.sync="add.dialogVisible"
    >
      <el-form ref="addForm" :model="add.form" :rules="add.rules" label-width="100px">
        <el-form-item :label="$t('姓名')" prop="name">
          <el-input v-model="add.form.name" :placeholder="$t('请输入学生姓名')" />
        </el-form-item>

        <el-form-item :label="$t('手机号')" prop="phone">
          <el-input v-model="add.form.phone" :placeholder="$t('请输入手机号')" />
        </el-form-item>

        <el-form-item :label="$t('微信号')" prop="wechat">
          <el-input v-model="add.form.wechat" :placeholder="$t('请输入微信号')" />
        </el-form-item>

        <el-form-item :label="$t('留言详情')">
          <el-input
            v-model="add.form.message_detail"
            type="textarea"
            :rows="4"
            :placeholder="$t('请输入留言详情（可选）')"
          />
        </el-form-item>

        <el-form-item v-if="schemes.length > 0" :label="$t('方案')" prop="scheme_index">
          <el-select
            v-model="add.form.scheme_index"
            :placeholder="$t('请选择方案')"
            :disabled="schemes.length === 1"
            style="width: 100%;"
          >
            <el-option
              v-for="(scheme, index) in schemes"
              :key="index"
              :label="scheme"
              :value="index"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="add.dialogVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" :loading="add.loading" @click="handleAddSubmit">{{ $t('确定') }}</el-button>
      </div>
    </el-dialog>

    <!-- 批量导入对话框 -->
    <el-dialog
      :title="$t('批量导入学生')"
      :visible.sync="batchImport.dialogVisible"
      width="800px"
    >
      <div style="margin-bottom: 20px;">
        <el-alert
          :title="$t('CSV文件格式说明')"
          type="info"
          :closable="false"
          show-icon
        >
          <template slot="default">
            <div style="line-height: 24px;">
              <p>{{ $t('CSV文件应包含以下字段（按顺序）：') }}</p>
              <p><strong>{{ $t('客户名称、手机号、微信、详细咨询信息') }}</strong></p>
              <p style="margin-top: 10px;">{{ $t('注意：第一行为表头，将从第二行开始导入数据') }}</p>
            </div>
          </template>
        </el-alert>
      </div>

      <div v-if="schemes.length > 0" style="margin-bottom: 20px;">
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <span style="width: 100px; text-align: right; margin-right: 10px;">{{ $t('选择方案') }}<span v-if="schemes.length > 1" style="color: red;">*</span>：</span>
          <el-select
            v-model="batchImport.scheme_index"
            :placeholder="$t('请选择方案')"
            :disabled="schemes.length === 1"
            style="flex: 1;"
          >
            <el-option
              v-for="(scheme, index) in schemes"
              :key="index"
              :label="scheme"
              :value="index"
            />
          </el-select>
        </div>
      </div>

      <el-upload
        ref="batchUpload"
        :auto-upload="false"
        :on-change="handleBatchFileChange"
        :file-list="batchImport.fileList"
        :limit="1"
        accept=".csv"
        drag
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">{{ $t('将CSV文件拖到此处，或') }}<em>{{ $t('点击上传') }}</em></div>
        <div slot="tip" class="el-upload__tip">{{ $t('只能上传CSV文件，且不超过10MB') }}</div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchImport.dialogVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" :loading="batchImport.loading" @click="handleBatchImportSubmit">{{ $t('开始导入') }}</el-button>
      </div>
    </el-dialog>

    <!-- 批量导入结果对话框 -->
    <el-dialog
      :title="$t('批量导入结果')"
      :visible.sync="batchImportResult.dialogVisible"
      width="900px"
    >
      <div style="margin-bottom: 20px;">
        <el-alert
          :title="`${$t('导入完成')}：${$t('成功')} ${batchImportResult.data.success_count || 0} ${$t('条')}，${$t('失败')} ${batchImportResult.data.fail_count || 0} ${$t('条')}`"
          :type="batchImportResult.data.fail_count > 0 ? 'warning' : 'success'"
          :closable="false"
          show-icon
        />
      </div>

      <div v-if="batchImportResult.data.fail_details && batchImportResult.data.fail_details.length > 0">
        <h4>{{ $t('失败详情') }}：</h4>
        <el-table
          :data="batchImportResult.data.fail_details"
          border
          style="width: 100%"
          max-height="400"
        >
          <el-table-column prop="line" :label="$t('行号')" width="80" align="center" />
          <el-table-column prop="name" :label="$t('客户名称')" min-width="120" />
          <el-table-column prop="reason" :label="$t('失败原因')" min-width="200" />
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchImportResult.dialogVisible = false; getList()">{{ $t('确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import Detail from '@/components/Larke/Detail'
import {
  getList,
  getDetail,
  createStudent,
  deleteData,
  updateStudent,
  batchImport
} from '../api/index'
import { getInfo } from '@/api/user'

export default {
  name: 'StudentIndex',
  components: { Pagination, Detail },
  directives: { waves, permission },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        searchword: '',
        start_time: '',
        end_time: '',
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
        item6: '',
        item7: '',
        item8: '',
        item9: '',
        item10: '',
        item11: '',
        order: 'create_time__DESC',
        page: 1,
        limit: 20
      },
      sortOptions: [
        { key: 'create_time__ASC', label: '正序' },
        { key: 'create_time__DESC', label: '倒叙' }
      ],
      pageSizes: [10, 20, 30, 50, 100],
      itemStatusOptions: [
        { value: 0, label: '未处理' },
        { value: 1, label: '已存在' },
        { value: 2, label: '成功' },
        { value: 3, label: '失败' }
      ],
      detail: {
        dialogVisible: false,
        data: []
      },
      schemes: [], // 方案列表
      add: {
        dialogVisible: false,
        loading: false,
        form: {
          name: '',
          student_no: '',
          age: 0,
          gender: 1,
          class: '',
          phone: '',
          wechat: '',
          email: '',
          message_detail: '',
          scheme_index: null
        },
        rules: {
          phone: [
            {
              validator: (rule, value, callback) => {
                if (!value && !this.add.form.wechat) {
                  callback(new Error(this.$t('手机号和微信号必须填写其中一个')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          wechat: [
            {
              validator: (rule, value, callback) => {
                if (!value && !this.add.form.phone) {
                  callback(new Error(this.$t('手机号和微信号必须填写其中一个')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          scheme_index: [
            {
              validator: (rule, value, callback) => {
                if (this.schemes.length > 1 && value === null) {
                  callback(new Error(this.$t('请选择方案')))
                } else {
                  callback()
                }
              },
              trigger: 'change'
            }
          ]
        }
      },
      selectedData: [],
      selectedRows: [],
      showDeletebtn: false,
      loading: {
        detail: '',
        delete: '',
        update: ''
      },
      batchImport: {
        dialogVisible: false,
        loading: false,
        fileList: [],
        scheme_index: null
      },
      batchImportResult: {
        dialogVisible: false,
        data: {
          success_count: 0,
          fail_count: 0,
          fail_details: []
        }
      }
    }
  },
  created() {
    this.getList()
    this.loadUserSchemes()
  },
  methods: {
    checkPermission,
    getList() {
      this.listLoading = true
      getList({
        searchword: this.listQuery.searchword,
        start_time: this.listQuery.start_time,
        end_time: this.listQuery.end_time,
        item1: this.listQuery.item1,
        item2: this.listQuery.item2,
        item3: this.listQuery.item3,
        item4: this.listQuery.item4,
        item5: this.listQuery.item5,
        item6: this.listQuery.item6,
        item7: this.listQuery.item7,
        item8: this.listQuery.item8,
        item9: this.listQuery.item9,
        item10: this.listQuery.item10,
        item11: this.listQuery.item11,
        order: this.listQuery.order,
        start: (this.listQuery.page - 1) * this.listQuery.limit,
        limit: this.listQuery.limit
      }).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSelectionChange(data, key) {
      this.selectedData = []
      this.selectedRows = data
      data.forEach(element => {
        this.selectedData.push(element.id)
      })

      if (this.selectedData.length > 0) {
        this.showDeletebtn = true
      } else {
        this.showDeletebtn = false
      }
    },
    handleAdd() {
      this.add.dialogVisible = true
      this.resetAddForm()
    },
    resetAddForm() {
      // 如果只有一个方案，自动选择第一个
      const schemeIndex = this.schemes.length === 1 ? 0 : null

      this.add.form = {
        name: '',
        student_no: '',
        age: 0,
        gender: 1,
        class: '',
        phone: '',
        wechat: '',
        email: '',
        message_detail: '',
        scheme_index: schemeIndex
      }
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate()
      }
    },
    handleAddSubmit() {
      // 如果有多个方案，必须选择方案
      if (this.schemes.length > 1 && this.add.form.scheme_index === null) {
        this.$message({
          message: this.$t('请选择方案'),
          type: 'warning',
          duration: 3 * 1000
        })
        return
      }

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.add.loading = true
          // 构建提交数据，如果只有一个方案且未选择，自动设置为0
          const submitData = { ...this.add.form }
          if (this.schemes.length === 1 && submitData.scheme_index === null) {
            submitData.scheme_index = 0
          }
          createStudent(submitData).then(response => {
            this.add.loading = false
            this.add.dialogVisible = false
            this.getList()
            this.$message({
              message: response.message,
              type: 'success',
              duration: 3 * 1000
            })
          }).catch(() => {
            this.add.loading = false
          })
        }
      })
    },
    handleDetail(index, row) {
      this.loading.detail = row.id

      getDetail(row.id).then((res) => {
        this.detail.dialogVisible = true
        const data = res.data

        this.loading.detail = ''

        this.detail.data = [
          {
            name: this.$t('ID'),
            content: data.id,
            type: 'text'
          },
          {
            name: this.$t('姓名'),
            content: data.name,
            type: 'text'
          },
          {
            name: this.$t('年龄'),
            content: data.age,
            type: 'text'
          },
          {
            name: this.$t('性别'),
            content: data.gender === 1 ? this.$t('男') : this.$t('女'),
            type: 'text'
          },
          {
            name: this.$t('手机号'),
            content: data.phone || '-',
            type: 'text'
          },
          {
            name: this.$t('微信号'),
            content: data.wechat || '-',
            type: 'text'
          },
          {
            name: this.$t('留言详情'),
            content: data.message_detail || '-',
            type: 'text'
          },
          {
            name: this.$t('意向度'),
            content: data.intent || '-',
            type: 'text'
          },
          {
            name: this.$t('反馈状态'),
            content: data.valid_flag_code || '-',
            type: 'text'
          },
          {
            name: this.$t('创建时间'),
            content: data.create_time,
            type: 'time'
          },
          {
            name: this.$t('状态'),
            content: data.status + '',
            type: 'boolen'
          }
        ]
      }).catch(() => {
        this.loading.detail = ''
      })
    },
    handleDelete(index, row) {
      this.$confirm(this.$t('确认要删除该学生吗？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        this.loading.delete = row.id

        deleteData(row.id).then(res => {
          this.loading.delete = ''
          this.list.splice(index, 1)

          this.$message({
            message: res.message,
            type: 'success',
            duration: 3 * 1000
          })
        }).catch(() => {
          this.loading.delete = ''
        })
      }).catch(() => {})
    },
    handleDeleteList() {
      this.$confirm(this.$t('确认要删除选中的学生吗？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        if (this.selectedData.length < 1) {
          this.$message({
            message: this.$t('请选择要删除的学生'),
            type: 'error',
            duration: 3 * 1000
          })
          return
        }

        this.$message({
          message: this.$t('删除选择的学生成功'),
          type: 'success',
          duration: 3 * 1000,
          onClose() {
            for (let i = this.list.length - 1; i >= 0; i--) {
              if (this.selectedData.includes(this.list[i].id)) {
                this.list.splice(i, 1)
              }
            }
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },
    handleUpdate(index, row) {
      this.loading.update = row.id
      updateStudent(row.id).then(response => {
        this.loading.update = ''
        this.getList() // 刷新列表
        this.$message({
          message: response.message,
          type: 'success',
          duration: 3 * 1000
        })
      }).catch(() => {
        this.loading.update = ''
      })
    },
    getValidFlagType(validFlagCode) {
      if (!validFlagCode) return 'info'
      const typeMap = {
        '未反馈': 'warning',
        '已反馈': 'success',
        '不符合报考条件': 'danger',
        '正在通话中': 'info'
      }
      return typeMap[validFlagCode] || 'info'
    },
    handleBatchImport() {
      this.batchImport.dialogVisible = true
      this.batchImport.fileList = []
      // 如果只有一个方案，自动选择第一个
      this.batchImport.scheme_index = this.schemes.length === 1 ? 0 : null
    },
    handleBatchFileChange(file, fileList) {
      this.batchImport.fileList = fileList
    },
    handleBatchImportSubmit() {
      if (this.batchImport.fileList.length === 0) {
        this.$message({
          message: this.$t('请选择要上传的CSV文件'),
          type: 'warning',
          duration: 3 * 1000
        })
        return
      }

      // 检查是否选择了方案（如果有多个方案）
      if (this.schemes.length > 1 && this.batchImport.scheme_index === null) {
        this.$message({
          message: this.$t('请选择方案'),
          type: 'warning',
          duration: 3 * 1000
        })
        return
      }

      // 如果只有一个方案，自动设置为0
      if (this.schemes.length === 1 && this.batchImport.scheme_index === null) {
        this.batchImport.scheme_index = 0
      }

      const file = this.batchImport.fileList[0].raw
      if (!file) {
        this.$message({
          message: this.$t('文件读取失败，请重新选择'),
          type: 'error',
          duration: 3 * 1000
        })
        return
      }

      // 验证文件大小（10MB）
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: this.$t('文件大小不能超过10MB'),
          type: 'error',
          duration: 3 * 1000
        })
        return
      }

      const formData = new FormData()
      formData.append('file', file)
      if (this.batchImport.scheme_index !== null) {
        formData.append('scheme_index', this.batchImport.scheme_index)
      }

      this.batchImport.loading = true
      batchImport(formData).then(response => {
        this.batchImport.loading = false
        this.batchImport.dialogVisible = false
        this.batchImport.fileList = []
        this.batchImport.scheme_index = null

        // 显示导入结果
        this.batchImportResult.data = response.data
        this.batchImportResult.dialogVisible = true

        this.$message({
          message: response.message,
          type: 'success',
          duration: 3 * 1000
        })
      }).catch(() => {
        this.batchImport.loading = false
      })
    },
    handleExport() {
      if (this.selectedRows.length === 0) {
        this.$message({
          message: this.$t('请选择要导出的学生'),
          type: 'warning',
          duration: 3 * 1000
        })
        return
      }

      // 定义CSV表头
      const headers = [
        this.$t('姓名'),
        this.$t('手机号'),
        this.$t('微信号'),
        this.$t('留言详情'),
        this.$t('国硕代理项目'),
        this.$t('美国硕博'),
        this.$t('新业务硕博'),
        this.$t('硕博在线项目'),
        this.$t('才大硕博'),
        this.$t('北京硕博'),
        this.$t('国际硕博'),
        this.$t('研之堂硕博'),
        this.$t('网络硕博'),
        this.$t('博士项目'),
        this.$t('重庆硕博'),
        this.$t('创建时间')
      ]

      // 状态值转换为文本
      const getItemStatusText = (value) => {
        if (value === 0) return this.$t('未处理')
        if (value === 1) return this.$t('已存在')
        if (value === 2) return this.$t('成功')
        if (value === 3) return this.$t('失败')
        return '-'
      }

      // 格式化时间
      const formatTime = (timestamp) => {
        if (!timestamp) return '-'
        const date = new Date(timestamp * 1000)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      }

      // 转义CSV字段（处理包含逗号、引号、换行符的情况）
      const escapeCsvField = (field) => {
        if (field === null || field === undefined) return ''
        const str = String(field)
        // 如果包含逗号、引号或换行符，需要用引号包裹，并转义引号
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
          return '"' + str.replace(/"/g, '""') + '"'
        }
        return str
      }

      // 构建CSV内容
      let csvContent = headers.map(escapeCsvField).join(',') + '\n'

      // 添加数据行
      this.selectedRows.forEach(row => {
        const rowData = [
          escapeCsvField(row.name || ''),
          escapeCsvField(row.phone || ''),
          escapeCsvField(row.wechat || ''),
          escapeCsvField(row.message_detail || ''),
          escapeCsvField(getItemStatusText(row.item1)),
          escapeCsvField(getItemStatusText(row.item2)),
          escapeCsvField(getItemStatusText(row.item3)),
          escapeCsvField(getItemStatusText(row.item4)),
          escapeCsvField(getItemStatusText(row.item5)),
          escapeCsvField(getItemStatusText(row.item6)),
          escapeCsvField(getItemStatusText(row.item7)),
          escapeCsvField(getItemStatusText(row.item8)),
          escapeCsvField(getItemStatusText(row.item9)),
          escapeCsvField(getItemStatusText(row.item10)),
          escapeCsvField(getItemStatusText(row.item11)),
          escapeCsvField(formatTime(row.create_time))
        ]
        csvContent += rowData.join(',') + '\n'
      })

      // 添加BOM以支持中文（UTF-8 with BOM）
      const BOM = '\uFEFF'
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })

      // 创建下载链接
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `学生数据_${new Date().getTime()}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      this.$message({
        message: this.$t('导出成功'),
        type: 'success',
        duration: 3 * 1000
      })
    },
    /**
     * 解析introduce字段，提取方案列表
     * 新格式：方案名称:项目1|项目2,方案名称2:项目1|项目2
     * 方案间用","分隔，方案名称和项目列表用":"分隔，方案内项目用"|"分隔
     */
    parseSchemes(introduce) {
      if (!introduce || !introduce.trim()) {
        return []
      }

      // 先按","分割得到方案数组
      const schemes = introduce.split(',').map(s => s.trim()).filter(s => s)

      // 如果没有逗号，说明只有一个方案（向后兼容）
      if (schemes.length === 0 && introduce.trim()) {
        return [introduce.trim()]
      }

      return schemes
    },
    /**
     * 加载用户方案列表
     */
    loadUserSchemes() {
      getInfo().then(response => {
        const introduce = response.data.introduce || ''
        this.schemes = this.parseSchemes(introduce)
      }).catch(() => {
        // 如果获取失败，方案列表为空
        this.schemes = []
      })
    }
  }
}
</script>

<style scoped>
.pagination-container {
  padding: 5px 2px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
